export default __webpack_public_path__ + "static/media/card_1.298b4fa5.svg";